export default "__VITE_ASSET__CJ0x2cAB__"